import { api } from '../constants/api';
import { post$, get$ } from './index';
import { getUser, isEmpty } from '../helpers/helper';

export const saveCallLog = (projectId, data) => {
  return post$(api.callLogs.saveCallLog.replace(':projectId', projectId), data);
};

export const getCallLogs = (projectId, data) => {
  return get$(api.callLogs.allCallLogs.replace(':projectId', projectId), data);
};

export const getContactRolesAPI = (projectId) => {
  return get$(api.contact.getContactRoles.replace(':projectId', projectId));
};

export const getAvailableContactsAPI = (projectId) => {
  return get$(api.contact.getAvailableContacts.replace(':projectId', projectId));
};

export const addContactPreferenceAPI = (projectId, contactId, contactType = 'company', is_in_contact_roles = false) => {
  return post$(api.contact.addContactPreference.replace(':projectId', projectId), {
    contact_id: contactId,
    contact_type: contactType,
    is_in_contact_roles: is_in_contact_roles
  });
};

export const hideContactPreferenceAPI = async (projectId, contactId, contactType = 'company') => {
  const { access } = await getUser();
  let token = access;
  if (isEmpty(token)) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  
  const url = `${process.env.REACT_APP_BASE_URL}/api/v1/${api.contact.removeContactPreference.replace(':projectId', projectId)}`;
  
  return fetch(url, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contact_id: contactId,
      contact_type: contactType,
      action: 'hide'
    })
  }).then(async (response) => {
    if (!response.ok) {
      const err = await response.json();
      return Promise.reject({ status: response.status, data: err });
    }
    return response.json();
  });
};

export const removeContactPreferenceAPI = async (projectId, contactId, contactType = 'company', contactRoleId = null) => {
  const { access } = await getUser();
  let token = access;
  if (isEmpty(token)) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  
  const url = `${process.env.REACT_APP_BASE_URL}/api/v1/${api.contact.removeContactPreference.replace(':projectId', projectId)}`;
  
  return fetch(url, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      contact_id: contactId,
      contact_type: contactType,
      action: 'remove',
      contact_role_id: contactRoleId
    })
  }).then(async (response) => {
    if (!response.ok) {
      const err = await response.json();
      return Promise.reject({ status: response.status, data: err });
    }
    return response.json();
  });
};

export const resetContactPreferencesAPI = async (projectId) => {
  const { access } = await getUser();
  let token = access;
  if (isEmpty(token)) {
    token = JSON.parse(localStorage.getItem("token"));
  }
  
  const url = `${process.env.REACT_APP_BASE_URL}/api/v1/${api.contact.removeContactPreference.replace(':projectId', projectId)}`;
  
  return fetch(url, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'reset'
    })
  }).then(async (response) => {
    if (!response.ok) {
      const err = await response.json();
      return Promise.reject({ status: response.status, data: err });
    }
    return response.json();
  });
};
